import { render, staticRenderFns } from "./RawData.vue?vue&type=template&id=39c8c8ac&scoped=true"
import script from "./RawData.vue?vue&type=script&lang=ts"
export * from "./RawData.vue?vue&type=script&lang=ts"
import style0 from "./RawData.vue?vue&type=style&index=0&id=39c8c8ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c8c8ac",
  null
  
)

export default component.exports